window.addToCartFromRecommendation = function(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(response => response.json())
  .then(data => {
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    const cartItems = document.querySelector('cart-items');
    
    if (cartDrawerItems) {
      cartDrawerItems.onCartUpdate().then(() => {
        setTimeout(() => {
          cartDrawerItems.updateFreeShippingMessageFromCart();
        }, 100);
      }).catch(() => {
        setTimeout(() => {
          cartDrawerItems.updateFreeShippingMessageFromCart();
        }, 100);
      });
    }
    
    if (cartItems) {
      cartItems.onCartUpdate().then(() => {
        setTimeout(() => {
          if (window.CartPageRecommendations) {
            window.CartPageRecommendations.loadRecommendationsForLastCartItem();
          }
        }, 200);
      }).catch(() => {
        setTimeout(() => {
          if (window.CartPageRecommendations) {
            window.CartPageRecommendations.loadRecommendationsForLastCartItem();
          }
        }, 200);
      });

      const customCartBar = document.getElementById('custom-cart-bar');
      if (customCartBar) {
        const sectionId = customCartBar.dataset.id;
        if (sectionId) {
          fetch(`${routes.cart_url}?section_id=${sectionId}`)
            .then(response => response.text())
            .then(responseText => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const newCustomCartBar = html.querySelector('#custom-cart-bar');
              if (newCustomCartBar) {
                customCartBar.innerHTML = newCustomCartBar.innerHTML;
                const newTotalElement = newCustomCartBar.querySelector('.custom-cart__total-value');
                if (newTotalElement) {
                  const cartItemsElement = document.querySelector('cart-items');
                  if (cartItemsElement && typeof cartItemsElement.syncCartTotalFromElement === 'function') {
                    cartItemsElement.syncCartTotalFromElement(newTotalElement);
                  }
                }
              }
            })
            .catch(console.error);
        }
      }
    }
    
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data, variantId: variantId });
    
    setTimeout(() => {
      if (window.CartRecommendationsManager) {
        window.CartRecommendationsManager.handleProductAdded(data);
      }
    }, 500);
  })
  .catch(error => console.error('Error adding product to cart:', error));
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    // If quantity is 0, remove the item instead of updating quantity
    if (inputValue === 0) {
      // Try to find remove button for cart page
      let removeButton = document.getElementById(`Remove-${index}`);
      // If not found, try drawer remove button
      if (!removeButton) {
        removeButton = document.getElementById(`CartDrawer-Remove-${index}`);
      }
      
      if (removeButton) {
        const removeButtonLink = removeButton.querySelector('a, button');
        if (removeButtonLink) {
          removeButtonLink.click();
          return;
        }
      }
      // Fallback: call updateQuantity with 0 (same as remove button does)
      this.updateQuantity(index, 0, event);
      return;
    }

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    const isDrawer = this.tagName === 'CART-DRAWER-ITEMS';
    const sectionId = isDrawer ? 'cart-drawer' : 'main-cart-items';
    
    return fetch(`${routes.cart_url}?section_id=${sectionId}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        if (isDrawer) {
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          selectors.forEach(selector => {
            const target = document.querySelector(selector);
            const source = html.querySelector(selector);
            if (target && source) target.replaceWith(source);
          });
        } else {
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        }
      })
      .catch(console.error);
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ];

    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents',
      });
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-contents',
      });
    }

    const customCartBar = document.getElementById('custom-cart-bar');
    if (customCartBar) {
      sections.push({
        id: 'custom-cart-bar',
        section: customCartBar.dataset.id,
        selector: '#custom-cart-bar',
      });
    }

    return sections;
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          
          if (parsedState.item_count === 0 && document.body.classList.contains('page-cart')) {
            window.location.reload();
            return;
          }
          
          const recommendationsContainer = document.getElementById('cart-recommendations');
          const recommendationsContent = recommendationsContainer ? recommendationsContainer.innerHTML : null;
          const recommendationsDisplay = recommendationsContainer ? recommendationsContainer.style.display : null;

          if (recommendationsContainer && parsedState.item_count === 0) {
            recommendationsContainer.style.display = 'none';
          }

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          });

          if (recommendationsContent && recommendationsDisplay && recommendationsContainer && parsedState.item_count > 0) {
            const newRecommendationsContainer = document.getElementById('cart-recommendations');
            if (newRecommendationsContainer && newRecommendationsContainer.innerHTML.includes('cart-recommendations-loading')) {
              newRecommendationsContainer.innerHTML = recommendationsContent;
              newRecommendationsContainer.style.display = recommendationsDisplay;
              
              setTimeout(() => {
                if (window.CartRecommendationsManager) {
                  window.CartRecommendationsManager.reinitializeSwiper();
                }
              }, 100);
            }
          }
          
          this.updateFreeShippingMessage(parsedState.total_price);
          this.syncCartTotal(parsedState.total_price);
          
          const updatedValue = parsedState.items[line - 1]?.quantity;
          const message = items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)
            ? (updatedValue === undefined ? window.cartStrings.error : window.cartStrings.quantityError.replace('[quantity]', updatedValue))
            : '';
          this.updateLiveRegions(line, message);

          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          const targetElement = lineItem?.querySelector(`[name="${name}"]`);
          
          if (targetElement) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, targetElement) : targetElement.focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
        if (this.tagName === 'CART-DRAWER-ITEMS' && window.CartRecommendationsManager) {
          if (event.currentTarget instanceof CartRemoveButton) {
            setTimeout(() => window.CartRecommendationsManager.handleCartUpdate(parsedState), 300);
          } else {
            setTimeout(() => {
              window.CartRecommendationsManager.reinitializeSwiper();
            }, 200);
          }
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  updateFreeShippingMessage(cartTotal) {
    const freeShippingMessage = document.getElementById('free-shipping-message');
    if (!freeShippingMessage) return;

    const threshold = window.Shopify?.theme?.settings?.free_shipping_threshold || 5000;
    const remaining = threshold - cartTotal;

    if (remaining > 0) {
      const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(remaining / 100);
      freeShippingMessage.innerHTML = `You are <strong>${money}</strong> away from free shipping.`;
    } else {
      freeShippingMessage.textContent = 'Congratulations! You qualify for free shipping.';
    }
  }

  updateFreeShippingMessageFromCart() {
    const totalElement = document.querySelector('.totals__total-value') || document.querySelector('.custom-cart__total-value');
    if (!totalElement) return;

    const totalText = totalElement.textContent || totalElement.innerText;
    const numericValue = totalText.replace(/[^\d.,]/g, '').replace(',', '');
    const cartTotal = parseFloat(numericValue) * 100;

    if (!isNaN(cartTotal)) {
      this.updateFreeShippingMessage(cartTotal);
      this.syncCartTotal(cartTotal);
    }
  }

  syncCartTotal(cartTotal) {
    const drawerTotal = document.querySelector('.totals__total-value');
    const cartPageTotal = document.querySelector('.custom-cart__total-value');
    
    if (drawerTotal && cartPageTotal) {
      const formattedMoney = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(cartTotal / 100);
      
      const currentCartText = cartPageTotal.textContent;
      const currentDrawerText = drawerTotal.textContent;
      
      if (currentCartText !== currentDrawerText) {
        cartPageTotal.textContent = formattedMoney;
        drawerTotal.textContent = formattedMoney;
      }
    }
  }

  syncCartTotalFromElement(totalElement) {
    const drawerTotal = document.querySelector('.totals__total-value');
    
    if (drawerTotal && totalElement) {
      const newTotalText = totalElement.textContent;
      const currentDrawerText = drawerTotal.textContent;
      
      if (currentDrawerText !== newTotalText) {
        drawerTotal.textContent = newTotalText;
      }
    }
  }


  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const spinners = [
      ...this.querySelectorAll(`#CartItem-${line} .loading__spinner`),
      ...this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`)
    ];
    spinners.forEach(overlay => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const spinners = [
      ...this.querySelectorAll(`#CartItem-${line} .loading__spinner`),
      ...this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`)
    ];
    spinners.forEach(overlay => overlay.classList.add('hidden'));
  }


}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class CartTimer {
  constructor() {
    this.timerElement = document.getElementById('cart-timer');
    this.minutesTensElement = document.getElementById('timer-minutes-tens');
    this.minutesOnesElement = document.getElementById('timer-minutes-ones');
    this.secondsTensElement = document.getElementById('timer-seconds-tens');
    this.secondsOnesElement = document.getElementById('timer-seconds-ones');
    
    this.timerInterval = null;
    this.totalSeconds = this.getTimerDuration();
    
    this.init();
  }
  
  getTimerDuration() {
    const duration = window.Shopify?.theme?.settings?.cart_timer_duration || 10;
    return duration * 60;
  }
  
  init() {
    if (!this.timerElement || !document.body.classList.contains('page-cart')) {
      return;
    }
    
    const cartItems = document.querySelectorAll('.cart-item');
    if (cartItems.length === 0) {
      return;
    }
    
    this.startTimer();
  }
  
  startTimer() {
    const storageKey = 'cart_timer_start';
    const now = Date.now();
    let startTime = localStorage.getItem(storageKey);
    
    if (!startTime) {
      localStorage.setItem(storageKey, now.toString());
      startTime = now;
    } else {
      startTime = parseInt(startTime);
    }
    
    const elapsed = Math.floor((now - startTime) / 1000);
    const remaining = this.totalSeconds - elapsed;
    
    if (remaining <= 0) {
      this.hideTimer();
      localStorage.removeItem(storageKey);
      return;
    }
    
    this.timerElement.style.display = 'flex';
    this.updateDisplay(remaining);
    
    this.timerInterval = setInterval(() => {
      const currentTime = Date.now();
      const currentElapsed = Math.floor((currentTime - startTime) / 1000);
      const currentRemaining = this.totalSeconds - currentElapsed;
      
      if (currentRemaining <= 0) {
        this.hideTimer();
        localStorage.removeItem(storageKey);
        clearInterval(this.timerInterval);
        return;
      }
      
      this.updateDisplay(currentRemaining);
    }, 1000);
  }
  
  updateDisplay(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    
    const minutesTens = Math.floor(minutes / 10);
    const minutesOnes = minutes % 10;
    
    const secondsTens = Math.floor(remainingSeconds / 10);
    const secondsOnes = remainingSeconds % 10;
    
    if (this.minutesTensElement) this.minutesTensElement.textContent = minutesTens;
    if (this.minutesOnesElement) this.minutesOnesElement.textContent = minutesOnes;
    if (this.secondsTensElement) this.secondsTensElement.textContent = secondsTens;
    if (this.secondsOnesElement) this.secondsOnesElement.textContent = secondsOnes;
  }
  
  hideTimer() {
    if (this.timerElement) {
      this.timerElement.style.display = 'none';
    }
  }
  
  resetTimer() {
    localStorage.removeItem('cart_timer_start');
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.startTimer();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartTimer();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartTimer();
  });
} else {
  new CartTimer();
}
